var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-v2"},[(_vm.$store.state.globalLoading)?_c('Loading'):_vm._e(),_c('div',{staticClass:"request-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }